var map = {
	"./archive.svg": 78875,
	"./cate.svg": 41620,
	"./day.svg": 51132,
	"./edit.svg": 99227,
	"./editMoney.svg": 29991,
	"./exchange.svg": 89136,
	"./layout.svg": 26194,
	"./live.svg": 82918,
	"./settings.svg": 82866,
	"./store.svg": 24930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57678;